import Cookies from 'js-cookie';
import c from 'utils/constants';

interface RESULT {
  isAdmin: boolean;
}

const useAdmin = (): RESULT => ({
  isAdmin: Cookies.get('_role') === c.ROLES.admin,
});

export default useAdmin;
